import template from './alert.html';
import './alert.scss'
let alertConfig = {
    template: template,
    data: {
        text: '提示内容'
    },
    actions: {
        close: function () {
            PMAPI.sendToParent({
                type: PMENUM.close_dialog,
                key: this.key,
                data: {
                    confirm: true
                }
            });
        }
    },
    afterRender: function () {
        this.el.find('.text p').html(decodeURIComponent(this.data.text));
        this.el.on('click', 'button', () => {
            this.actions.close();
        })
    }
}

export default alertConfig;


// WEBPACK FOOTER //
// app/components/util/alert/alert.js